import React from 'react';
import { Provider } from 'react-redux';
import initializeStore from './Reducer/initializeStore';
import Routes from './Router';
import MessageToast from './Components/NetworkMessageToast';
import Loader from './Components/Loader';
import './Images/font/flaticon.css';
import './App.css';

export const store = initializeStore();

const App = () => (
  <Provider store={store}>
    <Loader />
    <Routes />
    <MessageToast />
  </Provider>
);

export default App;
